import React from 'react'
import Sidebar from "../components/sidebar";
import Header from '../components/Header';
import GiftcardsListMain from '../components/Giftcards/GiftcardsListMain';

function GiftcardScreen() {
  return (
    <>
        <Sidebar />
        <main className="main-wrap">
            <Header />
            <GiftcardsListMain />
        </main>

    </>
  )
}

export default GiftcardScreen